import { WHITELABEL } from '../utils/constants'
import store from '@/store'

const whitelabel = {
    install(Vue) {
        Vue.mixin({
            methods: {
                whiteLabelName() {
                    const regex = new RegExp(`\\b(${WHITELABEL.whiteLabels.join('|')})\\b`)
                    let whitelabel = window.location.href.match(regex) ? window.location.href.match(regex)[0] : 'cashforce'
                    
                    if(process.env.VUE_APP_ROOT_ENVIROMENT === "local"){
                        whitelabel = process.env.VUE_APP_ROOT_USED_WHITELABEL
                    }
                    
                    return whitelabel
                }
            },
            computed: {
                getWhiteLabel() {
                    return WHITELABEL[this.whiteLabelName()].name
                },
                isCashforce(){
                    return this.getWhiteLabel === 'CASHFORCE'
                },
                getPrimaryColor() {
                    return WHITELABEL[this.whiteLabelName()].primaryColorName
                },
                getSecundaryColor() {
                    return WHITELABEL[this.whiteLabelName()].secundaryColorName
                },
                getPrimaryColorHex() {
                    return WHITELABEL[this.whiteLabelName()].primaryColorHex
                },
                getSecundaryColorHex() {
                    return WHITELABEL[this.whiteLabelName()].secundaryColorHex
                },
                getServiceUrls() {
                    const urls = WHITELABEL[this.whiteLabelName()].urls
                    store.commit('urls/setUrls', urls)
                    return urls
                },
                getPartners() {
                    return WHITELABEL.partners
                },
                setFavIcon() {
                    const favIcon = WHITELABEL[this.whiteLabelName()].favicon
                    const link = document.createElement("link")
                    
                    link.type = "image/x-icon"
                    link.rel = "shortcut icon"
                    link.href = favIcon
                    document.getElementsByTagName("head")[0].appendChild(link)

                    return favIcon
                },
                getWhiteLabelEmail() {
                    return WHITELABEL[this.whiteLabelName()].email
                },
                getContactWhiteLabel() {
                    return WHITELABEL[this.whiteLabelName()].contact
                },
                getIlustraPrimaryColor() {
                    const { primaryColorHex, ilustra } = WHITELABEL[this.whiteLabelName()]
                    if (ilustra) return ilustra.primary
                    return primaryColorHex.five
                },
                getIlustraSecundaryColor() {
                    const { secundaryColorHex, ilustra } = WHITELABEL[this.whiteLabelName()]
                    if (ilustra) return ilustra.secundary
                    return secundaryColorHex.five
                },
                usesSelfRegister() {
                    const partner = WHITELABEL[this.whiteLabelName()].name
                    const selfRegisterPartners = ['UNIVERSO']
                    return selfRegisterPartners.includes(partner)
                },
            },
        });
    },
};

export default whitelabel